module.exports = __webpack_public_path__ + "img/EyeExclamation-01.cb33f32b.svg";